import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'wo-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: [ './loading-bar.component.scss' ],
  standalone: true,
  imports: [
    NgIf,
  ],
})
export class LoadingBarComponent {
  @Input() public loading?: boolean | null;
}
